import { Configuration } from '@calm/evexia-web-sdk';
import { BaseAPI } from '@calm/evexia-web-sdk/generated/lib/base';
import { AxiosInstance } from 'axios';
import { browserClient } from './client/browser';

export const createApi = <T extends BaseAPI>(
    Api: new (
        config: Configuration,
        basePath?: string,
        axiosInstance?: AxiosInstance
    ) => T,
    accessToken: () => Promise<string>,
    client: AxiosInstance = browserClient
): T => {
    return new Api(
        new Configuration({ accessToken }),
        process.env.NEXT_PUBLIC_API_BASEURL,
        client
    );
};
